/**
 * Centralized env-contract accessor. Values come from the worksuite-fleet VITE_* contract
 * (variable groups for endpoints + auth, pipeline-computed for build/release metadata).
 *
 * Auth is PKCE-only: there is no `usePKCE` switch and no session-manager/cookie path. The auth
 * config (authority/client-id/tenant) is build-time `VITE_*` env baked into the static bundle —
 * inventory-pwa is a static SPA, so config is build-time, never runtime-mounted.
 */

/** Upgrade `http://` to `https://` for non-local builds to prevent mixed-content blocking when a
 *  variable group carries an http value. Local builds are left untouched. */
const enforceHttps = (url: string | undefined): string => {
	if (!url) return "";
	if (import.meta.env.VITE_BUILD_ENV === "local") return url;
	return url.replace(/^http:\/\//i, "https://");
};

const Config = {
	buildVersion: import.meta.env.VITE_BUILD_VERSION,
	releaseVersion: import.meta.env.VITE_RELEASE_VERSION,
	environment: import.meta.env.VITE_BUILD_ENV,
	branch: import.meta.env.VITE_BUILD_BRANCH,
	sentryDSN: "https://880547bf1fad4406a34fab9d2a43c777@o1137736.ingest.sentry.io/6190842",
	endpoint: enforceHttps(import.meta.env.VITE_GRAPHQL_ENDPOINT),
	authUrl: enforceHttps(import.meta.env.VITE_AUTH_URL),
	sfApiUrl: enforceHttps(import.meta.env.VITE_SF_API_URL),
	appName: import.meta.env.VITE_APPLICATION_NAME,
	clientId: import.meta.env.VITE_CLIENT_ID,
	tenantId: import.meta.env.VITE_TENANT_ID,
	tokenDuration: Number.parseInt(import.meta.env.VITE_TOKEN_DURATION_SECONDS, 10) || 3600
};

export default Config;
